import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300 } = GW_SERVICES_PREFIXES;

export const GetTabDescription = (provider_id: string) =>
  API.get(`/${C300}/creation_tab_description/`, provider_id);

// передавать id самого объекта коллекции RequestTabDescriptionForCreate
export const PatchTabDescription = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/creation_tab_description/`, id, params);
